import { render, staticRenderFns } from "./EsamiStrumentaliViewComponent.vue?vue&type=template&id=28d0fcd9"
import script from "./EsamiStrumentaliViewComponent.vue?vue&type=script&lang=js"
export * from "./EsamiStrumentaliViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports